
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brokerages",
      function () {
        return require("private-next-pages/brokerages/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brokerages"])
      });
    }
  